import "./IconLogOut.scss";
import { ReactComponent as LogOutIcon } from "./svg/icon_logOut.svg";

export const IconLogOut = () => {
  return (
    <span className="IconLogOut">
      <LogOutIcon />
    </span>
  );
};
